import en from 'element-ui/lib/locale/lang/en';
import de from 'element-ui/lib/locale/lang/de';

export const messages = {
    en: {
        ...en,
        forms: {
            password: "Password",
            firstName: "First name",
            lastName: "Last name",
            email: "Email",
            phone: "Phone",
            repeatPassword: "Repeat password",
            services: "Services",
            pickADay: "Pick a day",
            tomorrow: "Tomorrow",
            dayAfterTomorrow: "Day after tomorrow",
            selectTime: "Select time",
            selectEstimate: "Select estimate",
            description: "Description",
            selectService: "Select service",
            address: "Address",
            street: "Street",
            apartment: "Apartment",
            addAddress: "Add address",
            updateAddress: "Update address",
            newMessage: "Write a message...",
            orEnterAddress: "Or enter an address",
            chooseAddress: "Choose your address",
            chooseTime: "Choose a time",
            chooseService: "Select service",
            toThePrice: "to the price",
            noOrders: "No orders yet...",
            any_comments: "Any comments or suggestions?",
            rate_the_service: "How much did you like the service?",
            rate_the_master: "Rate the Master:",
            confirmRules: "By registering I confirm that I have read and agree to Better Interviews Terms of Service",
            confirmRulesLink: "Terms of Service",
            haveAccount: "Already have an account?",
            fotoUpload: "Upload photo/video",
            fotoUploadText: "Show us some good photos or videos of your project so that we can help you in the best way",
            areUSure: "Are you sure?",
            areUSureText: "Are you sure you want to delete it permanently?",
            deleteText: "Delete",
            cancelText: "Cancel",
            agreeSub: 'I agree to the Master Subscription Agreement.',
            yesGetEmails: 'Yes, I would like to receive marketing communications regarding Salesforce products, services, and events. I can unsubscribe at a later time.',
            billingAddress: "Billin address",
            sex: "Salutation",
            whoWillAccpetMaster: "Details of the person who will meet our master",
            enterAddress: "Enter address",
            mister: "Mr.",
            miss: "Mrs.",
            call: "Call",
            materialsListPriceInfoExcluded: "Travel and taxes excluded",

            thankUTitle: "Thank you for your inquiry!",
            thankUText: "We will contact you by phone within the next 60 minutes to coordinate your preferred date with you.",
            thankULink: "Check your order",

            publicCode: "Invalid Code",
            verifyInputTitle: "Enter the code from the message",

            privacyLink1: "Privacy Policy",
            privacyLink2: "Terms of Use",
            privacyAnd: "and",
            privacyTextPart1: "We value your Privacy! Please, read our",
            privacyTextPart2: "for information on how we handle your data and what your rights are. Note: we do not proceed in any way with your data until you submit your order.",
            photo: "photo"
        },
        modals: {
            details: "Order details"
        },
        buttons: {
            create: "Create",
            save: "Save",
            add: "Add",
            cancel: "Cancel",
            delete: "Delete",
            continue: "Continue",
            rate: "Rate",
            register: "Register",
            gotIt: "Got it"
        },
        nav: {
            createOrder: "Create order",
            orders: "Orders",
            landing: 'Landing page',
            privacy: "Privacy policy",
            termsOfUse: "Terms of use"
        },
        orders: {
            title: "Your orders",
            paymentType: "Payment type",
            getTheBill: "Get the bill",
            cash: "Cash",
            paymnetFailed: "Payment failed",
            retry: "Retry",
            anotherMethod: "Choose another payment method"
        },
        createOrder: {
            title: "Create order"
        },
        profile: {
            title: "Personal information"
        },
        ordersStatuses: {
            new: "Order is pending",
            confirmed: "Order confirmed",
            master_on_the_way: "Master on the way",
            master_arrived: "Master arrived",
            job_started: "Master is working",
            job_finished: "Master finished work",
            payment: "Payment",
            rating_review: "Rating",
            finished: "Finished",
            canceled: "Canceled",
            closed: "Closed",
            free: "Free",
            not_selected: "not selected",
            cash: "cash",
            card: "card",
            bill: "bill",
            stand_by: "Order is pending"
        },
        orderDetailsStatuses: {
            ew: "Order is pending",
            confirmed: "Order confirmed",
            master_on_the_way: "Master on the way",
            master_arrived: "Master arrived",
            job_started: "Master is working",
            job_finished: "Master finished work",
            payment: "Payment",
            rating_review: "Rating",
            canceled: "Canceled",
            closed: "Closed",
            stand_by: "Order is pending"
        },
        auth: {
            login: "Login",
            signup: "Sign up",
            forgot: "Forgot password",
            sendLink: "Send link",
            reset: "Reset password",
            continue: "Continue",
            codeSend: "A verification code has been sent to the specified phone number. This may take a few minutes",
            code: "Code",
            sendAgain: "Send again",
            sendAgainAfter: "Send again after",
            didntReceive: "Didn't receive the code?",
        },
        public: {
            passwordRecoveryTitle: "Passwort-Wiederherstellung",
            passwordChanged: "Passwort erfolgreich geändert",
            enterPassword: "Passwort eingeben",
            confirmPassword: "Passwort bestätigen",
            emailConfirmed: "Ihre E-Mail wurde erfolgreich bestätigt",
            somethingWentWrong: "Ups, etwas ist schief gelaufen"
        },
        alerts: {
            warning: "Warning",
            cancel: "Are you sure to cancel order?",
            deleteWarning: "This will permanently delete the account. Continue?",
            deleteAddressWarning: "This will permanently delete the address. Continue?",
            addressError: "Please enter a house number or postcode.",
            serviceDetails: "1 Hour for {price}",
            serviceDetails_15: "From the 2nd hour {price_fifteen} per beginning 15 minutes",
            serviceDetailsTrip: "All prices are net prices plus 20% VAT. The travel fee is within Vienna only €{trip}"
        },
        notifications: {
            successRegistration: "Success registration",
            successRegistrationText: "You've successfully registered an account. Confirm your email.",

            incorrectPassword: "Incorrect email or password",

            requestCreated: "Request created",
            requestCreatedText: "you've successfully created a request",

            profileUpdated: "Profile updated",
            profileUpdatedText: "you've successfully updated a profile",

            validationError: "Validation error",

            emailSent: "Email has been sent",
            emailSentText: "Confirmation email has been successfully sent.",

            codeSent: "A code has been already sent.",
            codeSentText: "Check out your phone. The code has been already sent.",

            codeNotVerided: "Code not verified",
            codeNotVeridedText: "Code not verified, incorrect code.",

            // emailSent: "Email has been sent",
            // emailSentText: "Confirmation email has been successfully sent.",

            adminSentMessage: "Admin sent a new message",
            adminSentMessageText: "Open chat to read messages"
        },
        services: {
            services: "Services",
            masterWork: "Masters work and Materials",
            priceCalculator: "Price calculator",

            electrician: "Electrician",
            plumber: "Plumber",
            floor_tiles: "Floor tiles",
            handyman: "Handyman"
        }
    },
    de: {
        ...de,
        forms: {
            password: "Passwort",
            firstName: "Vorname",
            lastName: "Nachname",
            email: "E-Mail",
            phone: "Telefonnummer",
            repeatPassword: "Passwort wiederholen",
            services: "Leistungen",
            pickADay: "Datum",
            tomorrow: "Tomorrow",
            dayAfterTomorrow: "Day after tomorrow",
            selectTime: "Wunschtermin",
            selectEstimate: "Voraussichtliche Arbeitsdauer",
            description: "Problembeschreibung",
            selectService: "Welche Dienstleistung benötigen Sie?",
            address: "Adresse",
            street: "Straße",
            apartment: "Apt./Büro №",
            addAddress: "Neue Adresse hinzufügen",
            updateAddress: "Adresse bearbeiten",
            newMessage: "Schreiben Sie eine Nachricht...",
            orEnterAddress: "Geben Sie eine neue Adresse ein ",
            chooseAddress: "Geben Sie Ihre Adresse ein",
            chooseTime: "Uhrzeit",
            chooseService: "Dienst auswählen",
            toThePrice: "zum Preis",
            noOrders: "Sie haben noch keine Aufträge",
            any_comments: "Schreibe dein Feedback",
            rate_the_service: "Wie sehr hat Ihnen der Service gefallen?",
            rate_the_master: "Den Meister bewerten:",
            confirmRules: "Mit der Registrierung bestätige ich, dass ich die Nutzungsbedingungen von Better Interviews gelesen habe und diesen zustimme",
            confirmRulesLink: "Nutzungsbedingungen",
            haveAccount: "Sie haben bereits ein Konto?",
            fotoUpload: "Foto/Video hochladen",
            fotoUploadText: "Zeige uns ein paar gute Bilder deines Projektes, damit wir dir bestmöglich helfen können.",
            areUSure: "Bist du sicher?",
            areUSureText: "Möchten Sie es wirklich dauerhaft löschen?",
            deleteText: "Löschen",
            cancelText: "Stornieren",
            agreeSub: 'Ich habe die AGB gelesen und akzeptiere diese',
            yesGetEmails: 'Ja, ich möchte Nachrichten zu Produkten, Dienstleistungen und Aktionen von Profy erhalten.Du kannst deine abonnierten Informationen jederzeit abbestellen.',
            billingAddress: "Rechnungsadresse",
            sex: "Anrede",
            whoWillAccpetMaster: "Angaben zur Person, der den Handwerker ampfäng.",
            enterAddress: "Geben Sie Ihre Adresse ein",
            mister: "Herr",
            miss: "Frau",
            call: "Anruf",
            materialsListPriceInfoExcluded: "Anfahrt und Steuer ausgeschlossen",

            thankUTitle: "Vielen Dank für Ihre Anfrage!",
            thankUText: "Wir werden uns innerhalb der nächsten 60 Minuten telefonisch bei Ihnen melden, um Ihren Wunschtermin mit Ihnen abzustimmen.",
            thankULink: "Überprüfen Sie Ihren Auftrag",

            publicCode: "ungültiger Code",
            verifyInputTitle: "Geben Sie den Code aus der Nachricht ein",

            privacyLink1: "Datenschutzrichtlinien",
            privacyLink2: "Nutzungsbedingungen",
            privacyTextPart1: "Wir schätzen Ihre Privatsphäre! Bitte lesen Sie unsere",
            privacyTextPart2: ", um Informationen darüber zu erhalten, wie wir mit Ihren Daten umgehen und welche Rechte Sie haben. Hinweis: Wir werden in keiner Weise mit Ihren persönlichen Daten fortfahren, bis Sie die Bestellung abschicken",
            photo: "Bild"
        },
        modals: {
            details: "Details"
        },
        buttons: {
            create: "Auftrag erstellen",
            save: "Speichern",
            add: "Fertig",
            cancel: "Abbrechen",
            delete: "Löschen",
            continue: "Fortfahren",
            rate: "Bewerten",
            register: "Registrieren",
            gotIt: "Habe es"
        },
        nav: {
            createOrder: "Bestellung erstellen",
            orders: "Meine Aufträge",
            landing: 'Startseite',
            privacy: "Datenschutzerklärung",
            termsOfUse: "Allgemeine Nutzungsbedingungen"
        },
        orders: {
            title: "Meine Aufträge",
            paymentType: "Zahlungsart",
            getTheBill: "Rechnung erhalten",
            cash: "Bezahlung in Bar oder mit Karte",
            paymnetFailed: "Bezahlung fehlgeschlagen",
            retry: "Wiederholen",
            anotherMethod: "Wählen Sie eine andere Zahlungsmethode"
        },
        createOrder: {
            title: "Auftrag erstellen"
        },
        profile: {
            title: "Persönliche Informationen"
        },
        ordersStatuses: {
            new: "Auftrag in Bearbeitung",
            confirmed: "Auftrag bestätigt",
            master_on_the_way: "Hanwerker ist unterwegs",
            master_arrived: "Handwerker ist eingetroffen",
            job_started: "Erledigt gerade deinen Auftrag",
            job_finished: "Auftrag erledigt",
            payment: "Wartet auf Bezahlung",
            rating_review: "Bewertung",
            finished: "Auftrag erledigt",
            canceled: "Bestellung storniert",
            closed: "Bestellung abgeschlossen",

            free: "Frei",
            not_selected: "nicht ausgewählt",
            cash: "kasse",
            card: "karte",
            bill: "gesetzentwurf",
            stand_by: "Anfrage gestellt"
        },
        orderDetailsStatuses: {
            new: "Anfrage gestellt",
            confirmed: "Auftrag bestatigt",
            master_on_the_way: "Handwerker ist unterwegs",
            master_arrived: "Handwerker ist eingetroffen",
            job_started: "Handwerker arbeitet",
            job_finished: "Der Auftrag ist erledigt",
            payment: "Bezahlung",
            rating_review: "Bewerte den Handwerker",
            closed: "Geschlossen",
            canceled: "Stornieren",
            stand_by: "Anfrage gestellt"
        },
        auth: {
            login: "Einloggen",
            signup: "Anmelden",
            sendLink: "Send link",
            reset: "Reset password",
            continue: "Weiter",
            forgot: "Passwort vergessen?",
            codeSend: "Bestätigungscode bereits angefordert. Wir haben den Bestätigungscode an die angegebene Telefonnummer gesendet. Es könnte einige Minuten dauern bis du ihn erhältst.",
            code: "Bestätigungscode",
            sendAgain: "Bestätigungscode erneut senden",
            sendAgainAfter: "Senden Sie erneut nach",
            didntReceive: "Den Bestätigungscode nicht erhalten?",
        },
        public: {
            passwordRecoveryTitle: "Passwort-Wiederherstellung",
            passwordChanged: "Passwort erfolgreich geändert",
            enterPassword: "Passwort eingeben",
            confirmPassword: "Passwort bestätigen",
            emailConfirmed: "Ihre E-Mail wurde erfolgreich bestätigt",
            somethingWentWrong: "Ups, etwas ist schief gelaufen"
        },
        alerts: {
            warning: "Warnung",
            cancel: "Sind Sie sicher, die Bestellung zu stornieren?",
            deleteWarning: "Dadurch wird das Konto dauerhaft gelöscht. Fortsetzen?",
            deleteAddressWarning: "Dadurch wird die Adresse dauerhaft gelöscht. Fortsetzen?",
            addressError: "Bitte geben Sie eine Hausnummer oder PLZ ein.",
            serviceDetails: "1. Stunde für {price}",
            serviceDetails_15: "Ab der 2. Stunde {price_fifteen}. Je angefangenen 15 Minuten",
            serviceDetailsTrip: "Alle Preise sind Nettopreise plus 20% Ust. Die Anfahrtspauschale beträgt innerhalb Wien nur €{trip}"
        },
        notifications: {
            successRegistration: "Erfolgsregistrierung",
            successRegistrationText: "Sie haben erfolgreich ein Konto registriert. Bestätige deine E-Mail.",

            incorrectPassword: "Falsche Email oder Passwort",

            requestCreated: "Anfrage erstellt",
            requestCreatedText: "Sie haben erfolgreich eine Anfrage erstellt",

            profileUpdated: "Profil aktualisiert",
            profileUpdatedText: "Sie haben ein Profil erfolgreich aktualisiert",

            validationError: "Validierungsfehler",

            // emailSent: "Die E-mail wurde verschickt",
            // emailSentText: "Bestätigungs-E-Mail wurde erfolgreich gesendet.",

            codeSent: "Ein Code wurde bereits gesendet.",
            codeSentText: "Überprüfen Sie Ihr Telefon. Der Code wurde bereits gesendet.",

            codeNotVerided: "Der Code ist nicht verifiziert.",
            codeNotVeridedText: "Der Code ist nicht verifiziert, der Code ist falsch.",

            emailSent: "Email wurde gesendet.",
            emailSentText: "Bestätigungsmail wurde erfolgreich gesendet",

            adminSentMessage: "Administrator hat eine neue Nachricht gesendet",
            adminSentMessageText: "Chat öffnen, um Nachrichten zu lesen"
        },
        services: {
            services: "Leistungen",
            masterWork: "Meisterarbeit und Materialien",
            priceCalculator: "Preisrechner",

            electrician: "Elektriker",
            plumber: "Installateur",
            floor_tiles: "Böden/Fliesen",
            handyman: "Handwerker"
        }
    }
}